import type { LinkProps } from '@mui/material';
import { InfoIcon } from '@noah-labs/fe-shared-ui-assets/muiSvgIcons/InfoIcon';
import { TextWithIcon } from '../typography/TextWithIcon';
import { InlineLinkOrButton } from './InlineLinkOrButton';

export function InfoTooltip({ children, onClick, ...rest }: LinkProps): React.ReactElement {
  return (
    <InlineLinkOrButton
      color="inherit"
      underline="none"
      variant="inherit"
      onClick={onClick}
      {...rest}
    >
      <TextWithIcon>
        <span>{children}</span>
        {!!onClick && <InfoIcon fontSize="inherit" />}
      </TextWithIcon>
    </InlineLinkOrButton>
  );
}
